import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const editAtmType = ( {data, atmTypeId} : {data: IPostEditAtmType | {}, atmTypeId: number}): Promise<string> => {
  return axiosDefaultApi.put(`/api/AtmTypes/UpdateAtmType/${atmTypeId}`, data);
};

type QueryFnType = typeof editAtmType;

type UseEditAtmTypeOptions = {
  data: IPostEditAtmType | {};
  atmTypeId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditAtmType = ({ config }: UseEditAtmTypeOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία του Τύπου.`, 500);
            console.error('Couldnt edit AtmType', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllAtmTypes"])
            addNotification('Ο Τύπος Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editAtmType,
    })
}